import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { Guideline, RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';

const MedicalCriteria3 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { onValueCheckboxFilterChange, getFilterValueCheckboxValue },
  } = useRootStore();

  // Values for radio buttons group
  const radioButtons = [
    {
      id: '5003_MI',
      label: 'Blue Cross Blue Shield',
      value: '5003_MI',
    },
    {
      id: '1291_MI',
      label: 'Priority Health',
      value: '1291_MI',
    },
    {
      id: 'all',
      label: 'No Preference',
      value: 'all',
    },
  ];

  return (
    <div>
      <TextBlock title="Carrier" subtitle="Do you have a carrier preference?" />
      <RadioGroup
        label=""
        value={getFilterValueCheckboxValue('carrier')}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onValueCheckboxFilterChange('carrier', e.target.value);
        }}
      />
      <Guideline
        simpleStyles
        labels={{
          opened: 'What to consider when picking carriers',
          closed: 'What to consider when picking carriers',
        }}
        className={classes.guidelineWrapper}
        content={
          <>
            <ul className={classes.guidelineList}>
              <li className={classes.guidelineItem}>
                All of the insurance providers represented on the Wahoo site have been vetted by experienced insurance
                agents – so you can be confident of receiving coverage from a reputable insurance provider
              </li>
              <li className={classes.guidelineItem}>
                Each carrier has developed their own networks and participating providers will be important to your
                employee’s access of healthcare
              </li>
              <li className={classes.guidelineItem}>
                Some carriers may have strong brand name recognition than others and this may assist with employee
                recruitment and retention
              </li>
            </ul>
          </>
        }
      />
    </div>
  );
});

export default withCriteria(MedicalCriteria3, 3);
